import { Component, inject } from '@angular/core';
import { TranslationManagementListConfigService } from '../../services/translation-management-list-config/translation-management-list-config.service';

@Component({
    selector: 'lib-translation-management-list',
    templateUrl: './translation-management-list.component.html',
    styleUrls: ['./translation-management-list.component.css'],
    standalone: false
})
export class TranslationManagementListComponent {
   public translationManagementListConfigService = inject(TranslationManagementListConfigService);

}
